import {
    observable,
} from "mobx";

class QuizObjectTracking {
    @observable _quizObject: number = 0;
    @observable _title: number = 0;
    @observable _definition: number = 0;

    applyScore(score: number) {
        if (isNaN(score)) {
            return 0;
        }
        return score;
    }

    get quiz_object() {
        return this._quizObject;
    }

    get title() {
        return this._title;
    }

    get definition() {
        return this._definition;
    }

    set quiz_object(score: number) {
        this._quizObject = this.applyScore(score);
    }

    set title(score: number) {
        this._title = this.applyScore(score);
    }

    set definition(score: number) {
        this._definition = this.applyScore(score);
    }
}

export {
    QuizObjectTracking
}